<div class="centerWidth">
    <div class="header-svg" >
        <svg  width="657" height="627" viewBox="0 0 657 627" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1582.41" y="-1007" width="761.879" height="1865.11" rx="380.94" transform="rotate(58.0414 1582.41 -1007)" stroke="url(#paint0_linear_853_14385)" stroke-width="3"/>
            <rect x="1538.7" y="-818.295" width="487.945" height="1591.17" rx="243.973" transform="rotate(58.0414 1538.7 -818.295)" stroke="url(#paint1_linear_853_14385)" stroke-width="2"/>
            <rect x="1494.99" y="-629.591" width="214.011" height="1317.24" rx="107.006" transform="rotate(58.0414 1494.99 -629.591)" stroke="url(#paint2_linear_853_14385)"/>
            <defs>
                <linearGradient id="paint0_linear_853_14385" x1="2057.88" y1="996.448" x2="2069.78" y2="387.196" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#5200FF"/>
                    <stop offset="1" stop-color="#00C8BC"/>
                </linearGradient>
                <linearGradient id="paint1_linear_853_14385" x1="1888.82" y1="1039.67" x2="1884.92" y2="442.806" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#5200FF"/>
                    <stop offset="1" stop-color="#00C8BC"/>
                </linearGradient>
                <linearGradient id="paint2_linear_853_14385" x1="1736.14" y1="1064.73" x2="1703.55" y2="489.985" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#5200FF"/>
                    <stop offset="1" stop-color="#00C8BC"/>
                </linearGradient>
            </defs>
        </svg>
    </div>
    <div class="update-body">
        <div class="flex">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M47.9974 5.3335C49.4702 5.3335 50.6641 6.5274 50.6641 8.00016V10.6668H53.3307C54.8035 10.6668 55.9974 11.8607 55.9974 13.3335C55.9974 14.8063 54.8035 16.0002 53.3307 16.0002H50.6641V18.6668C50.6641 20.1396 49.4702 21.3335 47.9974 21.3335C46.5246 21.3335 45.3307 20.1396 45.3307 18.6668V16.0002H42.6641C41.1913 16.0002 39.9974 14.8063 39.9974 13.3335C39.9974 11.8607 41.1913 10.6668 42.6641 10.6668H45.3307V8.00016C45.3307 6.5274 46.5246 5.3335 47.9974 5.3335ZM25.3307 6.66683C26.4521 6.66683 27.4536 7.36834 27.8368 8.42218C30.9478 16.9774 37.6868 23.7164 46.242 26.8274C47.2959 27.2106 47.9974 28.2121 47.9974 29.3335C47.9974 30.4548 47.2959 31.4564 46.242 31.8396C37.6868 34.9506 30.9478 41.6896 27.8368 50.2448C27.4536 51.2986 26.4521 52.0002 25.3307 52.0002C24.2094 52.0002 23.2078 51.2986 22.8246 50.2448C19.7136 41.6896 12.9747 34.9506 4.41941 31.8396C3.36558 31.4564 2.66406 30.4548 2.66406 29.3335C2.66406 28.2121 3.36558 27.2106 4.41941 26.8274C12.9747 23.7164 19.7136 16.9774 22.8246 8.42218C23.2078 7.36834 24.2094 6.66683 25.3307 6.66683ZM25.3307 15.6842C22.1049 21.3868 17.384 26.1076 11.6814 29.3335C17.384 32.5594 22.1049 37.2802 25.3307 42.9828C28.5566 37.2802 33.2774 32.5594 38.9801 29.3335C33.2774 26.1076 28.5566 21.3868 25.3307 15.6842ZM49.3307 45.0734C48.1792 46.6982 46.7882 48.134 45.2086 49.3335C46.7882 50.533 48.1792 51.9687 49.3307 53.5936C50.4823 51.9687 51.8733 50.533 53.4528 49.3335C51.8733 48.134 50.4823 46.6982 49.3307 45.0734ZM46.4372 39.6396C47.7478 37.4553 50.9136 37.4553 52.2243 39.6396L53.0916 41.0852C54.4803 43.3997 56.5001 45.2701 58.9142 46.4771C61.268 47.654 61.268 51.013 58.9142 52.1898C56.5001 53.3969 54.4803 55.2673 53.0916 57.5817L52.2243 59.0273C50.9136 61.2117 47.7478 61.2118 46.4372 59.0273L45.5698 57.5817C44.1812 55.2673 42.1613 53.3969 39.7472 52.1898C37.3935 51.013 37.3935 47.654 39.7472 46.4771C42.1613 45.2701 44.1812 43.3997 45.5698 41.0852L46.4372 39.6396Z" fill="#00113D"/>
            </svg>
            <h2 style="top: -8px;position: relative;" i18n="@@Updates">Updates</h2>
        </div>
        <div class="val">
            <section>
                <div>
                    <span style="font-weight: bold;">ورژن 3.21  </span> <span> - </span>
                    <span>۲۹ آبان ۱۴۰۲</span>
                </div>
                <div style="font-weight: bold;" >بهبود پیشنهاد پرس‌وجو</div>
                <ul>
                    <li>امکان اضافه کردن دسته‌بندی از نوع Object در پیشنهاد پرس‌وجو</li>
                    <li>امکان دسته‌بندی چند سطحی</li>
                    <li>Api کلمات غیر مجاز در پیشنهاد پرس‌وجو</li>
                    <li>اضافه شدن پارامتر IN_CONTENT</li>
                    <li>افزودن قابلیت‌های جدید Facet</li>
                    <li>امکان اضافه کردن فیلدهای بازیابی همراه فست</li>
                    <li>امکان ایجاد Facet محدوده‌ای</li>
                    <li>امکان ایجاد فست پویا</li>
                </ul>
                <div style="font-weight: bold;">بهبود عملکرد جستجو</div>
                <ul>
                    <li>جست‌وجو دسته‌ای</li>
                    <li>امکان Geo Distance</li>
                    <li>امکان گروه بندی</li>
                </ul>

            </section>
            <section>
                <div>
                    <span style="font-weight: bold;">ورژن 3.19  </span> <span> - </span>
                    <span>۲۲ آبان ۱۴۰۲</span>
                </div>
                <div style="font-weight: bold;" >بهبود پیشنهاد پرس‌وجو</div>
                <ul>
                    <li>امکان اضافه کردن دسته‌بندی از نوع Object در پیشنهاد پرس‌وجو</li>
                    <li>امکان دسته‌بندی چند سطحی</li>
                    <li>Api کلمات غیر مجاز در پیشنهاد پرس‌وجو</li>
                    <li>اضافه شدن پارامتر IN_CONTENT</li>
                    <li>افزودن قابلیت‌های جدید Facet</li>
                    <li>امکان اضافه کردن فیلدهای بازیابی همراه فست</li>
                    <li>امکان ایجاد Facet محدوده‌ای</li>
                    <li>امکان ایجاد فست پویا</li>
                </ul>
                <div style="font-weight: bold;">بهبود عملکرد جستجو</div>
                <ul>
                    <li>جست‌وجو دسته‌ای</li>
                    <li>امکان Geo Distance</li>
                    <li>امکان گروه بندی</li>
                </ul>

            </section>
            <section>
                <div>
                    <span style="font-weight: bold;">ورژن 3.18  </span> <span> - </span>
                    <span>۳۱ شهریور ۱۴۰۲</span>
                </div>
                <div style="font-weight: bold;" >بهبود پیشنهاد پرس‌وجو</div>
                <ul>
                    <li>امکان اضافه کردن دسته‌بندی از نوع Object در پیشنهاد پرس‌وجو</li>
                    <li>امکان دسته‌بندی چند سطحی</li>
                    <li>Api کلمات غیر مجاز در پیشنهاد پرس‌وجو</li>
                    <li>اضافه شدن پارامتر IN_CONTENT</li>
                    <li>افزودن قابلیت‌های جدید Facet</li>
                    <li>امکان اضافه کردن فیلدهای بازیابی همراه فست</li>
                    <li>امکان ایجاد Facet محدوده‌ای</li>
                    <li>امکان ایجاد فست پویا</li>
                </ul>
                <div style="font-weight: bold;">بهبود عملکرد جستجو</div>
                <ul>
                    <li>جست‌وجو دسته‌ای</li>
                    <li>امکان Geo Distance</li>
                    <li>امکان گروه بندی</li>
                </ul>

            </section>

        </div>
    </div>
</div>


